
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const service = namespace("service");
const setting = namespace("setting");
@Component({})
export default class Resettle extends Vue {
  @Prop({ type: Boolean, default: false })
  confirmBtnLoading;
  @setting.Action getPatternPaymentList;
  @service.Action getOrderDetail;
  @service.Action returnOrder;
  @service.Action queryReturnOrderParts;
  @service.Action queryReturnOrderStaffCommission;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  detailData: any = {};
  payWayList: any[] = [];
  formData: any = {
    orderNo: "",
    paymentAmount: "",
    paymentMethod: "",
    remark: ""
  };
  formDataRules: any = {
    remark: { required: true, message: t("v210831.please-enter-refund"), trigger: "blur" }
  };
  partsTableData: any = [];
  staffTableData: any = [];
  currentStepIndex: number = 0;
  isLoad: boolean = false;
  stepList: any = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.formData.orderNo = this.orderId;
    this.init();
  }
  async init() {
    let payListData = await this.getPatternPaymentList({
      status: "1"
    });
    this.payWayList = payListData.data || [];

    let detailData = await this.getOrderDetail({
      orderNo: this.orderId
    });
    this.detailData = detailData.data;
    if (this.detailData.settlementStatus === "1") {
      if (this.detailData.paymentList && this.detailData.paymentList.length) {
        this.formData.paymentMethod = this.detailData.paymentList[0].paidMethod;
        let totalPrice = 0;
        this.detailData.paymentList.forEach(v => {
          totalPrice += v.paidAmount * 1;
        });
        this.formData.paymentAmount = totalPrice;
      } else {
        // 退款金额为0
        this.formData.paymentMethod = this.payWayList[0].payMethodCode;
        this.formData.paymentAmount = 0;
      }
    }

    let partsData = await this.queryReturnOrderParts({
      orderNo: this.orderId
    });
    this.partsTableData = partsData.data;

    let staffData = await this.queryReturnOrderStaffCommission({
      orderNo: this.orderId
    });
    this.staffTableData = staffData.data;

    if (this.detailData.settlementStatus === "1") {
      this.stepList.push({
        name: t("v210831.refund"),
        info: t("v210831.the-chargeback-settlement-tips1")
      });
    }
    if (this.partsTableData.length) {
      this.stepList.push({
        name: t("v210831.return-stock-in"),
        info: t("v210831.the-return-settlement")
      });
    }
    if (this.staffTableData.length) {
      this.stepList.push({
        name: t("v210831.deduction-of-commission"),
        info: t("v210831.the-chargeback-settlement-tips2")
      });
    }
    this.isLoad = true;
  }
  handleClose() {
    if (this.$listeners.cancel) {
      this.$emit("cancel");
    } else {
      this.$emit("update:visible", false);
    }
  }
  handleLastStep() {
    this.currentStepIndex = this.currentStepIndex - 1;
  }
  handleNextStep() {
    if (this.stepList[this.currentStepIndex] && this.stepList[this.currentStepIndex].name === t("v210831.refund")) {
      (this.$refs.contentForm as any).validate(valid => {
        if (valid) {
          this.currentStepIndex = this.currentStepIndex * 1 + 1;
        } else {
          return;
        }
      });
    } else {
      this.currentStepIndex = this.currentStepIndex * 1 + 1;
    }
  }
  isDoing: any = false;
  confirm() {
    if (this.isDoing) {
      return;
    }
    this.isDoing = true;
    if (this.stepList[this.currentStepIndex] && this.stepList[this.currentStepIndex].name === t("v210831.refund")) {
      (this.$refs.contentForm as any).validate(valid => {
        if (valid) {
          this.returnOrder({ ...this.formData })
            .then(() => {
              this.$emit("confirm");
            })
            .catch(() => {
              this.isDoing = false;
            });
        } else {
          this.isDoing = false;
          return;
        }
      });
    } else {
      this.returnOrder({ ...this.formData })
        .then(() => {
          this.$emit("confirm");
        })
        .catch(() => {
          this.isDoing = false;
        });
    }
  }
  handleLinkReceipt(orderData) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${orderData.receiptNo}`
    });
    window.open(href, "_blank");
  }
}
